export default function getSubdomain() {
  const hostname = window.location.hostname;
  console.log("Hostname:", hostname);

  // Handle specific full domains
  if (hostname === "app-prokuroria.cmdsoftwares.com") {
    return "app-prokuroria"; // Use a normalized key
  }
  if (hostname === "prokuroria-rks.org") {
    return "prokuroria-rks.org"; // Return JSON key directly
  }

  // Handle localhost and local subdomains (e.g., kpk.localhost)
  const parts = hostname.split(".");
  if (hostname.includes("localhost")) {
    if (parts.length > 1 && parts[0] !== "prokuroria-rks.org") {
      return parts[0]; // e.g., 'kpk' from 'kpk.localhost'
    }
    return "app-prokuroria"; // Default for localhost
  }

  // Handle real subdomains (e.g., kpk.prokuroria-rks.org)
  if (parts.length > 2) {
    return parts[0]; // e.g., 'kpk' from 'kpk.prokuroria-rks.org'
  }

  // Default for other domains (no subdomain)
  return "prokuroria-rks.org"; // Return JSON key for default case
}